<template>
  <parent>
    <div class="healthcheck-log-form-wrapper popup-wrapper">
      <div class="popup">
        <div class="popup__header">
          <h6 class="bold">
            Log Details
          </h6>
          <b-form-checkbox
            v-model="theme"
            class="custom-control-dark pb-1 ml-2"
            name="check-button"
            switch
            value="vs-dark"
            unchecked-value="vs"
          >
            <span class="switch-icon-left"> <GjIcon name="Idea" /> </span>
            <span class="switch-icon-right">
              <GjIcon name="Idea_fill" />
            </span>
          </b-form-checkbox>
          <a
            class="ml-auto"
            @click="$emit('close')"
          ><GjIcon name="Close" /></a>
        </div>
        <div
          class="popup__body pt-1"
          :class="{ 'set-height': loadingHealthcheckLog }"
        >
          <template>
            <b-tabs
              v-model="tabIndex"
              content-class="pt-1"
              fill
            >
              <b-tab
                active
                title="Response Headers"
              >
                <div
                  v-if="tabIndex === 0"
                  class="p-1"
                >
                  <div
                    v-if="loadingHealthcheckLog"
                    class="loading-editor text-center"
                  >
                    <b-spinner variant="primary" />
                  </div>
                  <response-editor
                    v-else
                    editor-id="responseHeaders"
                    :value="formatString(healthcheckLog.responseHeaders)"
                  />
                </div>
              </b-tab>
              <b-tab title="Response Body">
                <div
                  v-if="tabIndex === 1"
                  class="p-1"
                >
                  <div
                    v-if="loadingHealthcheckLog"
                    class="loading-editor text-center"
                  >
                    <b-spinner variant="primary" />
                  </div>
                  <response-editor
                    v-else
                    editor-id="responseBody"
                    :theme-light="false"
                    :value="formatString(healthcheckLog.responseBody)"
                  />
                </div>
              </b-tab>
            </b-tabs>
          </template>
        </div>
      </div>
    </div>
  </parent>
</template>

<script>
import ResponseEditor from './ResponseEditor.vue'

export default {
  name: 'HealthcheckLogDetails',
  components: {
    ResponseEditor,
  },
  props: {},
  data() {
    return {
      tabIndex: null,
    }
  },
  computed: {
    theme: {
      get() {
        return this.$store.state.app.editorLightTheme
      },
      set(val) {
        this.$store.commit('app/SET_EDITOR_THEME', val)
      },
    },
    loadingHealthcheckLog() {
      return this.$store.state.healthcheckLogs.gettingHealthcheckLog
    },
    healthcheck() {
      return this.$store.state.healthchecks.healthcheck
    },
    healthcheckLog() {
      return this.$store.state.healthcheckLogs.healthcheckLog
    },
  },
  created() {},
  methods: {
    formatString(value) {
      if (typeof value === 'object') {
        const temp = JSON.stringify(value)
        return temp
      }
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.set-height {
  padding: 15px;
}
.popup {
  overflow: hidden;
  .popup__body {
    ::v-deep {
      padding: 0;
      .loading-editor {
        margin-top: 10rem;
      }
      .tab-content {
        padding-top: 1px !important;
      }
      .tab-pane {
        min-height: 260px;
        div {
          padding: 0 !important;
        }
      }
    }
  }
}
</style>
